import Image from 'next/image';
import { FaCheckCircle } from 'react-icons/fa';
import RatingStars from 'generic/RatingStars';
import { useTextFontOverrides, useHeadingFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';
import { buildImgProps } from 'utils/media';

import type {
  ComponentsTestimonialSocialReview,
  ComponentsTestimonialSocialReviewStyle,
} from 'queries/graphql';

import styles from './styles.module.scss';

export default function SocialReview({
  userName,
  userImage,
  title,
  text,
  rating,
  socialReviewStyle,
}: ComponentsTestimonialSocialReview & {
  socialReviewStyle?: ComponentsTestimonialSocialReviewStyle;
}) {
  const {
    userNameColor,
    headingColor,
    textColor,
    backgroundColor,
    verifiedColor,
    starColor,
    starEmptyColor,
    headingFont,
    textFont,
  } = socialReviewStyle || {};

  const headingFontOverrides = useHeadingFontOverrides(headingFont);
  const textFontOverrides = useTextFontOverrides(textFont);

  return (
    <div className={`root ${styles.container}`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--user-name-color', userNameColor, 'var(--text-color-dark)')}
          ${buildCssVar('--heading-color', headingColor, 'var(--heading-color-dark)')}
          ${buildCssVar('--text-color', textColor, 'var(--text-color-dark)')}
          ${buildCssVar('--background-color', backgroundColor, 'var(--secondary-color)')}
          ${buildCssVar('--verified-color', verifiedColor, 'var(--color-positive)')}
          ${headingFontOverrides ?? ''}
          ${textFontOverrides ?? ''}
        }
      `}</style>

      {userImage && (
        <div className={styles.img_wrapper}>
          <Image {...buildImgProps(userImage)} alt={userImage.alt || 'User Image'} />
        </div>
      )}

      {!!rating && (
        <div className={styles.icon_wrapper}>
          <RatingStars rating={rating} style={{ starColor, starEmptyColor }} />
        </div>
      )}

      <div className={styles.review_body}>
        <h5>{title}</h5>
        <p>{text}</p>
      </div>

      <div className={styles.user_name}>
        <p>{userName}</p>
      </div>

      <div className={styles.verified_container}>
        <div className={styles.verified_icon}>
          <FaCheckCircle />
        </div>
        <p>VERIFIED BUYER</p>
      </div>
    </div>
  );
}
